<template>
  <div>
    <pro-homepage-sub-menu/>
    <pro-h2/>
    <how-it-works/>
    <value-props/>
    <services-to-offer/>
    <how-to-join-checklist/>
    <pro-short-testimonials/>
    <pro-faq-section/>
    <looking-for-something/>
    <customer-pro-modal v-if="showProModal"/>
  </div>
</template>

<script>
import { prefetchMixin } from '@/prefetch';
import Storage from '@homeservices/tool-kit/storage/local-storage';
import ProHomepageSubMenu from './components/ProHomepageSubMenu';
import HowToJoinChecklist from './components/HowToJoinChecklist';
import ProShortTestimonials from './components/ProShortTestimonials';
import HowItWorks from './components/HowItWorks';
import ValueProps from './components/ValueProps';
import LookingForSomething from './components/LookingForSomething';
import ProH2 from './components/ProH2';
import FAQSection from './components/FAQSection';
import ServicesToOffer from './components/ServicesToOffer';
import CustomerProModal from '../CustomerProModal';

const USER_TYPE = 'USER_TYPE_VALUE';
export default {
  name: 'app',
  components: {
    ProHomepageSubMenu,
    HowToJoinChecklist,
    ProShortTestimonials,
    HowItWorks,
    ValueProps,
    LookingForSomething,
    ProH2,
    'pro-faq-section': FAQSection,
    ServicesToOffer,
    CustomerProModal,
  },
  mixins: [
    prefetchMixin,
  ],
  prefetch ({ store }) {
    return Promise.all([
      store.dispatch('homepage/proServices/fetchProOccupationsWithServices'),
      store.commit('homepage/geo/resetLocations'),
      store.dispatch('homepage/request/reset'),
      store.dispatch('homepage/search/reset'),
      store.dispatch('homepage/contentful/fetchProHomePage'),
      store.commit('homepage/setIsProHomepage', true),
    ]);
  },
  data () {
    return {
      showProModal: true,
      stickyTriggerPoint: 465,
    };
  },
  mounted () {
    if (this.$route.query.source) {
      Storage.set(USER_TYPE, 'PRO_USER');
      this.showProModal = false;
    }
  },
};
</script>
